import { Button } from '@mui/material';
import BalanceIcon from '@mui/icons-material/Balance';
import { H6, Body3 } from '../../../../../themes/typography';

function TaxInfoSidebar() {
    return (
        <div className="kyc-info-sidebar-container">
            <div className="kyc-info-icon-header">
                <div className="kyc-info-icon">
                    <BalanceIcon color="tertiary" sx={{ fontSize: '3rem' }} />
                </div>
            </div>

            <div className="kyc-info-title-desc">
                <H6 color="var(--secondary-color)" fontWeight={700}>
                    Why do we need this information?
                </H6>
                <Body3>
                    Company details are required to identify you and for tax invoicing purposes.
                </Body3>
            </div>

            <div className="community-message-container">
                <Body3>
                    Identity verification required to identify you for tax invoicing purposes
                </Body3>
            </div>

            <div className="community-message-container">
                <Body3>PAN details mandatory as per Section 1940 of Income Tax Act</Body3>
            </div>

            <div className="community-message-container">
                <Body3>TCS and TDS applicable as per government regulations</Body3>
            </div>

            <div className="learn-more-about-btn">
                <Button
                    fullWidth
                    sx={{
                        fontSize: '0.875rem',
                        border: '1px solid var(--tertiary-color)',
                        color: 'var(--tertiary-color)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            color: 'var(--secondary-color)',
                            backgroundColor: 'transparent',
                            borderColor: 'var(--secondary-color)'
                        }
                    }}
                >
                    Click to know more →
                </Button>
            </div>
        </div>
    );
}

export default TaxInfoSidebar;
